import ObservablePropertyDescriptorObject from '../../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../../utils/PropertyDescriptor';

export default class Model extends ObservablePropertyDescriptorObject {

    toString() {
        return "设置";
    }

    run(data, opts) {

    }
}
